import React from 'react';
import { List, Tag, Typography } from 'antd';
import { notifications } from '../mockData';
import './Notifications.css';

function Notifications() {
  const { Title } = Typography;

  return (
    <div className="agency-notifications">
      <Title level={3}>Notifications</Title>
      <List
        bordered
        dataSource={notifications}
        renderItem={(n) => (
          <List.Item
            actions={[<Tag key="status" color={n.read ? 'default' : 'blue'}>{n.read ? 'READ' : 'NEW'}</Tag>, <span key="time">{n.time}</span>]}
          >
            <List.Item.Meta title={n.title} description={n.body} />
          </List.Item>
        )}
      />
    </div>
  );
}

export default Notifications;
